import React from "react";
import Modal from "../../lib/ModalWindow/Modal";
import LoginForm from "./LoginForm/LoginForm";

const NotloggedinModal: React.FC<{isVisible: boolean; closeFunction: () => void; onLoggedIn?: () => void}> = ({
  isVisible,
  closeFunction,
  onLoggedIn,
}) => {
  return (
    <Modal isVisible={isVisible} closeFunction={closeFunction}>
      <LoginForm onLoggedIn={onLoggedIn} />
    </Modal>
  );
};

export default NotloggedinModal;
